/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"

export const itemPreviewStyle = css`
  .item-img-wrapper {
    width: 100%;
    .item-img {
      max-width: 100%;
    }
    .close-icon {
      position: absolute;
      left: 10px;
      top: 40px;
      border-radius: 50%;
      padding: 5px;
      background: #1a1a1a;
      mix-blend-mode: normal;
      opacity: 0.48;
      color: white;
      font-size: 25px;
    }
  }
  .item-overview,
  .item-modifier {
    background: #fff;
    padding: 24px 15px;
  }
  .item-overview {
    .item-name,
    .item-price {
      font-weight: 500;
      font-size: 17px;
    }
    .item-price {
      margin-bottom: 0;
    }
    .base-price-label {
      margin-bottom: 0;
      font-size: 11px;
      color: #777575;
    }
  }
  .item-modifier {
    margin-top: 10px;
    .modifier-group-name {
      font-size: 16px;
      font-weight: 500;
    }
    .modifier-group-name span {
      font-size: 12px;
      font-weight: normal;
      color: #979797;
    }
  }
  .modifier-wrapper {
    display: inline-block;
  }
  .dui-radio-wrapper {
    border-bottom: 1px solid rgba(5, 5, 5, 0.06);
  }
  .modifier-wrapper {
    width: 265px;
  }
  .modifier-wrapper span:nth-of-type(1) {
    font-size: 16px;
    color: #2d2d2d;
  }
  .modifier-wrapper span:nth-of-type(2) {
    font-size: 16px;
    color: #979797;
    float: right;
  }
  .item-description {
    background: #fff;
    padding: 0 15px;
    color: #979797;
  }
  .item-button {
    padding: 10px;
    background: #fff;
    button {
      background-color: #8a8a8a !important;
    }
  }
  .item-button-enabled {
    padding: 10px;
    background: #fff;
    button {
      background-color: #33c072 !important;
    }
  }
`

export const phonePreviewStyle = css`
  .preview-screen {
    background: #f5f5f5;
    height: 600px;
    overflow: hidden;
    border-radius: 17.1626px;
    position: relative;
  }
  .overlay {
    background-color: rgba(26, 26, 26, 0.48);
    position: absolute;
    z-index: 2;
    color: #ffffff;
    width: 100%;
    padding: 0 7px;
    height: 21.98px;
  }
  .black-frame {
    background: #1a1a1a;
    height: 663px;
    border-radius: 36.6135px;
  }
  .phone-sensor {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .long-white {
    width: 172.77px;
    height: 5.72px;
    border-radius: 14.8742px;
    background: #ffffff;
  }
  .circle-white-1 {
    position: absolute;
    margin-left: 210px;
    width: 5.72px;
    height: 5.72px;
    border-radius: 50%;
    background: #ffffff;
  }
  .circle-white-2 {
    position: absolute;
    margin-left: 240px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #ffffff;
  }
`

export const headerDiv = css`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: 160px;
`

export const headerPictureStyle = css`
  flex-shrink: 0;
  max-width: 100%;
  min-width: 100%;
  min-height: 100%;
`

export const preferredMerchantStyle = css`
  color: #00b14f;
  font-size: 11px;
  font-weight: 500px;
`

export const itemPictureStyle = css`
  width: 64px;
  height: 64px;
  border-radius: 4px;
`

export const descriptionStyle = css`
  font-size: 11px;
  font-weight: 300px;
`
